import React, { useLayoutEffect, useRef } from 'react';
import { Input } from 'antd';

// credentialing 本地专用电话输入：输入框直接显示格式化后的 (908) 555-5503（真实文本、原生光标），
// 不用共享 USPhoneInput 的「透明输入框 + 覆盖层」写法（那种写法光标落在未格式化的原始数字上，永远对不齐）。
// value 仍然是纯数字，onChange 也只吐纯数字，保持与原有表单字段一致的契约。
type Props = {
    value?: string;
    onChange?: (val: string) => void;
    size?: 'large' | 'middle' | 'small';
    placeholder?: string;
    disabled?: boolean;
};

const formatPhone = (raw?: string) => {
    const d = (raw || '').replace(/\D/g, '').slice(0, 10);
    if (!d) return '';
    if (d.length < 4) return `(${d}`;
    if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

export default function CredPhoneInput({ value = '', onChange, ...rest }: Props) {
    const inputRef = useRef<any>(null);
    // 值更新后要还原的光标位置（以「第几个数字之后」映射回格式化串的下标）
    const caretRef = useRef<number | null>(null);
    const display = formatPhone(value);

    useLayoutEffect(() => {
        const el: HTMLInputElement | undefined = inputRef.current?.input;
        if (caretRef.current != null && el) {
            el.setSelectionRange(caretRef.current, caretRef.current);
            caretRef.current = null;
        }
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const el = e.target;
        const caret = el.selectionStart ?? el.value.length;
        // 光标前有几个数字
        const digitsBefore = el.value.slice(0, caret).replace(/\D/g, '').length;
        const raw = el.value.replace(/\D/g, '').slice(0, 10);
        const formatted = formatPhone(raw);
        // 把「digitsBefore 个数字之后」映射到格式化串里的下标
        let pos = 0;
        let seen = 0;
        while (pos < formatted.length && seen < digitsBefore) {
            if (/\d/.test(formatted[pos])) seen += 1;
            pos += 1;
        }
        caretRef.current = pos;
        onChange?.(raw);
    };

    return (
        <Input
            ref={inputRef}
            inputMode="numeric"
            value={display}
            onChange={handleChange}
            {...rest}
        />
    );
}
